export const DataNotificationsTypes = {
  TYPE_CONSTRUCTION: 'ConstructionUpdate',
  TYPE_CONSTRUCTION_NOTE: 'ConstructionNoteUpdate',
  TYPE_THREAD: 'MessageNew',
  TYPE_PRIZE: 'PrizeChoose',
  TYPE_PROFILE: 'FilledProfile',
  TYPE_POINTS: 'PointsUpdate',
  TYPE_EXTRAPOINTS: 'ExtraPoints',
  TYPE_USER_ACTIVATION: 'UserActivation',
};
